























































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  RsNetworkMeter,
  SlaveControl,
  NetworkData,
  SimplifyMeter,
} from "@/api/baseDefine";

import { formatDate, formatDateTime } from "../../utils/dateUtil";
import { SendDataReq, sendData } from "@/api/meter";
import {
  GetRsNetworkDatasReq,
  getRsNetworkDatas,
  sendEventLogRequest,
  SendEventLogRequestReq,
} from "@/api/rsNetwork";
@Component
export default class RsNetworkAdvanceDialog extends Vue {
  private sendCommand = null;
  private baudRate: number = 0;
  private selectBaudRates: number[] = [
    2400,
    4800,
    9600,
    19200,
    38400,
    115200,
    153600,
  ];
  private rsNetworkAdvanceDialogShow: boolean = false;
  private form: SlaveControl = <SlaveControl>{};
  private tableData: NetworkData[] = [];
  private sendTableData: NetworkData[] = [];
  private selectCommands;
  private rsNetworkInstantValueCommandNames: string[] = [];
  private rsNetworkMeter: RsNetworkMeter = <RsNetworkMeter>{};
  private tableDataIndexMap: Map<string, NetworkData> = new Map();
  private clickShow(rsNetworkMeter: RsNetworkMeter) {
    this.rsNetworkMeter = rsNetworkMeter;
    console.log("RsNetworkAdvanceDialog click show", rsNetworkMeter);
    this.rsNetworkAdvanceDialogShow = true;
    this.form.meterID = rsNetworkMeter.meter.meterID;
    this.form.NetworkName = rsNetworkMeter.rsNetworkName;
    for (let d of this.tableData) {
      d.response = "";
      d.LastReportTime = "";
      this.$set(this.tableData, d.i, d);
    }
  }

  private async getNetworkData() {
    let req: GetRsNetworkDatasReq = <GetRsNetworkDatasReq>{};
    req.meterID = this.form.meterID;
    let res = await getRsNetworkDatas(req);
    if (res.code == ResCode.SUCCESS) {
      if (!!res.data && !!res.data.datas && res.data.datas.length > 0) {
        for (let d of res.data.datas) {
          let rsNetworkData:
            | NetworkData
            | undefined = this.tableDataIndexMap.get(d.command);

          if (!rsNetworkData) {
            continue;
          }
          rsNetworkData.response = d.response + d.unit;
          rsNetworkData.LastReportTime = d.LastReportTime;
          this.$set(this.tableData, rsNetworkData.i, rsNetworkData);
        }
      }
    }
  }

  private created() {
    let self = this;
    let names = this.$t("RsNetworkInstantValueCommandNames") as any;
    for (let i = 0; i < names.length; i++) {
      let commandName = String(names[i]);
      let ss = commandName.split("|");
      let is = i.toString(16);
      let length = is.length;
      for (let j = length; j < 4; j++) {
        is = "0" + is;
      }
      let rsNetworkAdvanceRespose = <NetworkData>{
        i: i,
        name: ss[0],
        LastReportTime: "",
        response: "",
        command: ss[1],
        count: ss[2],
      };
      this.sendTableData.push(rsNetworkAdvanceRespose);
      if (i != names.length - 1) {
        this.tableData.push(rsNetworkAdvanceRespose);
      }

      this.rsNetworkInstantValueCommandNames.push(names[i]);
      this.tableDataIndexMap.set(
        rsNetworkAdvanceRespose.command,
        rsNetworkAdvanceRespose
      );
    }
    setInterval(function () {
      if (self.rsNetworkAdvanceDialogShow) {
        self.getNetworkData();
      }
    }, 5000);
  }

  private async send() {
    console.log("send", this.sendCommand);
    if (!this.sendCommand) {
      this.$message({
        message: this.$t("notification.inputIllegal").toString(),
        type: "warning",
      });
      return;
    }
    let networkData: NetworkData | undefined = this.tableDataIndexMap.get(
      String(this.sendCommand)
    );
    let command = this.sendCommand;
    if (command == "1111") {
      command = "0000" as any;
    }
    if (!networkData) {
      return;
    }
    console.log("networkData",networkData)
    let req: SendDataReq = <SendDataReq>{};
    req.meterIDs = [];
    req.meterIDs.push(<SimplifyMeter>{
      meterID: this.rsNetworkMeter.masterMeter.meterID,
      meterTypeID: this.rsNetworkMeter.masterMeter.meterTypeID,
    });
    req.dataType = 8;
    let index = 10 + this.rsNetworkMeter.index;
    let baudIndex =
      this.selectBaudRates.indexOf(this.rsNetworkMeter.baudRate) + 1;
    if (baudIndex <= 0) {
      baudIndex = 4;
    }
    req.params =
      index +
      "04" +
      "," +
      command +
      "," +
      networkData.count +
      "," +
      baudIndex +
      "," +
      "10" +
      "," +
      this.rsNetworkMeter.meter.meterID; // type 10是rs network
    let res = await sendData(req);
  }

  private async sendEventLog() {
    let req: SendEventLogRequestReq = <SendEventLogRequestReq>{};
    req.masterMeterId = this.rsNetworkMeter.masterMeter.meterID;
    req.masterMeterTypeID = this.rsNetworkMeter.masterMeter.meterTypeID;
    req.meterID = this.rsNetworkMeter.meter.meterID;
    req.index = this.rsNetworkMeter.index;
    let res = await sendEventLogRequest(req);
  }

  private async reset() {
    let req: SendDataReq = <SendDataReq>{};
    req.meterIDs = [];
    req.meterIDs.push(<SimplifyMeter>{
      meterID: this.rsNetworkMeter.meter.meterID,
      meterTypeID: this.rsNetworkMeter.meter.meterTypeID,
    });
    req.dataType = -1;
    let res = await sendData(req);
    if (res.code == ResCode.SUCCESS) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].response = "";
        this.tableData[i].unit = "";
        this.tableData[i].LastReportTime = "";
        // this.$set(this.tableData, this.tableData[i].i, this.tableData[i]);
      }
    }
  }
}
